module.exports = __webpack_public_path__ + "img/f1.4908e694.jpeg";